import React from 'react';
import PropTypes from 'prop-types';
import UserCard from '../Global/Teasers/UserCard';

const CuratedFavouritesAuthor = ({ author, message, loggedInUser, doIFollowCurator, onFollowClick, classes }) => (
  <div className={`curated-favourites-author d-flex flex-column bg-green color-white border-radius-l p-a-3 ${classes}`}>
    <div className="text-center m-t-auto">
      <h3 className="like-p fw-bold text-uppercase letter-spacing-s m-b-2">{"Coaches notes on this week's picks"}</h3>
      <p className="fw-medium"><i>“{message}”</i></p>
    </div>

    <div className="bg-white border-radius-l box-shadow m-t-auto">
      <UserCard
        user={author}
        doIFollow={doIFollowCurator}
        loggedInUser={loggedInUser}
        onFollowClick={onFollowClick}
      />
    </div>
  </div>
);

CuratedFavouritesAuthor.propTypes = {
  author: PropTypes.object.isRequired,
  message: PropTypes.string.isRequired,
  loggedInUser: PropTypes.object,
  doIFollowCurator: PropTypes.array.isRequired,
  onFollowClick: PropTypes.func.isRequired,
  classes: PropTypes.string,
};

export default CuratedFavouritesAuthor;



// WEBPACK FOOTER //
// ./library/app/components/TrainingGround/CuratedFavouritesAuthor.js